module.exports = __webpack_public_path__ + "img/tengelyek_szama.0f16e0a8.svg";